export default __webpack_public_path__ + "static/media/edit.f0c14d46.mp4";